import cx from 'classnames'
import type React from 'react'

import useActions from '../../hooks/useActions'
import { IconPlus } from '../../icons'
import cssNode from '../../Node.module.scss'
import css from './Children.module.scss'

type Props = {
  nodeId: string
}

const Children: React.FC<Props> = ({ nodeId }) => {
  const { onCreateChild } = useActions(nodeId)

  return (
    <div
      className={cx(cssNode.actionButton, css.button, 'node-button-children')}
      onClick={onCreateChild}
      data-testid="add_page"
    >
      <IconPlus />
    </div>
  )
}

export default Children
